export default __webpack_public_path__ + "static/media/yt-pause-icon.de3e7095.svg";